import { type ComponentProps, useId } from "react";
import { useTranslation } from "./i18n";
import { useDialogFocus } from "./lib/accessibility";
import TermOverview from "./TermOverview";

export default function TermComparisonDialog({
  onClose,
  ...overview
}: ComponentProps<typeof TermOverview> & { onClose: () => void }) {
  const { t } = useTranslation("gradeOverview");
  const { t: exportText } = useTranslation("localExport");
  const titleId = useId();
  const dialogRef = useDialogFocus<HTMLElement>(true, onClose, () =>
    document.getElementById("coursework-term-comparison-trigger"),
  );
  return (
    <div
      className="term-comparison-backdrop"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <section
        ref={dialogRef}
        className="paper-card term-comparison-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
      >
        <header>
          <h2 id={titleId} className="term-comparison-title">
            {t("dashboard.compareTerms")}
          </h2>
          <button type="button" onClick={onClose}>
            {exportText("close")}
          </button>
        </header>
        <TermOverview {...overview} />
      </section>
    </div>
  );
}
